<script setup lang="ts">
import { useI18n } from "vue-i18n";
import router from "@/router";
import { useUserStore } from "@/stores/userStore";
import OutlineButton from "@/components/buttons/OutlineButton.vue";
import { ROUTE_NAMES } from "@/constants/routeNames";

const { t } = useI18n();
const userStore = useUserStore();

function showPurchasedMatrix(matrixDate: string) {
  router.push({
    name: ROUTE_NAMES.DESTINY_MATRIX,
    query: { init_date: matrixDate },
  });
}
</script>

<template>
  <div class="flex mt-6 mb:mt-10 justify-center">
    <div class="flex-1 max-w-[812px] bg-white rounded-[20px] pt-[30px]">
      <!-- TITLE -->
      <div class="flex items-center justify-center mb-6 md:mb-10 relative">
        <p
          class="sf-pro font-semibold text-xl max-md:leading-[24px] md:text-2xl max-md:pl-4"
        >
          {{ t("destiny-matrix-purchased-dates-table.title") }}
        </p>
      </div>
      <!-- FAMILY TABLE -->
      <div class="rounded-[20px] overflow-y-auto">
        <table class="w-full text-left overflow-hidden">
          <thead class="bg-brown max-md:hidden px-10">
            <tr>
              <th class="th-item pl-10">
                {{ t("destiny-matrix-purchased-dates-table.date") }}
              </th>
              <th class="th-item">
                {{ t("destiny-matrix-purchased-dates-table.actions") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="matrixDate in userStore.user.products['destiny_matrix']"
              :key="matrixDate"
              class="h-20 border-b border-ternary last:border-b-0"
            >
              <td class="px-10">{{ matrixDate }}</td>
              <td>
                <OutlineButton
                  class="px-4 py-2"
                  :isLoading="false"
                  :btn-text="t('destiny-matrix-purchased-dates-table.show-btn')"
                  @click="showPurchasedMatrix(matrixDate)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.th-item {
  @apply text-white font-semibold text-xl leading-[24px] py-9;
}
</style>
